/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

nve-grid-row:has(nve-grid-cell:first-child [nve-control] > input:checked) nve-grid-cell {
  --background: var(--nve-sys-interaction-highlighted-muted-background);
  --interaction-state-ratio: var(--nve-sys-interaction-state-ratio-selected);
}

nve-grid:has(nve-grid-cell:first-child nve-radio),
nve-grid:has(nve-grid-cell:first-child nve-checkbox) {
  --grid-auto-columns: 36px minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
}

nve-grid[container='flat'] nve-grid-header {
  --background: var(--nve-sys-layer-canvas-background);
}

nve-card,
nve-panel,
nve-dialog,
nve-drawer,
nve-accordion {
  nve-grid[container='flat'] {
    nve-grid-header {
      --background: var(--nve-sys-layer-container-background);
    }
  }
}

nve-grid-cell:has(> nve-icon-button) {
  --padding: 0 var(--nve-ref-size-100);
}

nve-grid-cell:has(> nve-checkbox),
nve-grid-cell:has(> nve-radio) {
  --padding: var(--nve-ref-size-200) var(--nve-ref-size-300);
}

nve-grid:has(nve-toolbar:not([hidden]))::part(_scrollbox) {
  padding-block-end: var(--nve-ref-size-1000);
}

nve-grid:has(nve-toolbar:not([hidden])) {
  contain: content;
}

nve-grid-column > nve-sort-button + nve-icon-button {
  margin-inline-start: initial;
}

nve-grid-cell:focus-within > a {
  box-shadow: 0 0 0 2px Highlight; /* programmatic focus does not trigger standard outline style */
}

nve-grid {
  &:has([scroller]) nve-grid-header {
    --padding: 0 16px 0 0;
  }

  & [scroller] {
    scrollbar-color: var(--nve-sys-scrollbar-thumb-color) var(--nve-sys-scrollbar-track-color);
    scrollbar-width: var(--nve-sys-scrollbar-width);
  }
}
